import React from 'react';
import {Grid, ListItem, Theme} from '@mui/material';
import {makeStyles} from "@mui/styles";

import {getAuthServiceInstance} from '../services/auth';

import {NavLink, useNavigate, useLocation,} from "react-router-dom";
import {colorPrimary} from "./index";

const useStyles = makeStyles((theme: Theme) => ({
  menuContainer: {
    height: 596,
    marginTop: 10,
  },
  menuItem: {
    width: 87,
    paddingLeft: 13,
  },
  menuItemSelected: {
    width: 90,
    borderRightStyle: 'solid',
    borderRightWidth: 3,
    borderRightColor: colorPrimary,
  },
  menuText: {
    marginTop: 5,
    fontSize: 13,
    // '&:hover': {
    //   fontSize:20,
    // }
  },
  menuTextSelected: {
    marginTop: 5,
    fontSize: 13,
    color: theme.palette.primary.main,
  },
}))

const getLastPathname = (pathname: string): string => {
  const pathnameSplit = pathname.split('/')
  return pathnameSplit[pathnameSplit.length - 1]
}

function MenuItem(props: any) {
  const classes = useStyles();
  const {image, selectedImage, text, link, selected} = props;

  return (
    <ListItem
      button
      component={NavLink}
      to={link}
      className={selected ? classes.menuItemSelected : classes.menuItem}
    >
      <Grid container direction={'column'} alignItems={'center'}>
        <Grid item>
          <img src={selected ? selectedImage : image} alt={text}/>
        </Grid>
        <Grid item className={selected ? classes.menuTextSelected : classes.menuText}>
          <span>{text}</span>
        </Grid>
      </Grid>
    </ListItem>
  )
}


export default function MenuListItems() {
  const classes = useStyles();
  const navigate = useNavigate();

  const location = useLocation();
  const selected = getLastPathname(location.pathname)
  const basename = '/app'

  return (
    <Grid container direction={'column'} justifyContent="space-between" alignItems="center" className={classes.menuContainer}>
      <Grid item>
        <Grid container direction={'column'} alignItems="center" spacing={1}>
          <Grid item>
            <MenuItem
              image={process.env.PUBLIC_URL + '/static/images/menu_order.svg'}
              selectedImage={process.env.PUBLIC_URL + '/static/images/menu_order_selected.svg'}
              text={'운송주문'}
              link={`${basename}/freight/order`}
              selected={selected === 'order'}
            />
          </Grid>
          <Grid item>
            <MenuItem
              image={process.env.PUBLIC_URL + '/static/images/menu_inquiry.svg'}
              selectedImage={process.env.PUBLIC_URL + '/static/images/menu_inquiry_selected.svg'}
              text={'운송조회'}
              link={`${basename}/freight/inquiry`}
              selected={selected === 'inquiry'}
            />
          </Grid>
          <Grid item>
            <MenuItem
              image={process.env.PUBLIC_URL + '/static/images/menu_settling.svg'}
              selectedImage={process.env.PUBLIC_URL + '/static/images/menu_settling_selected.svg'}
              text={'정산'}
              link={`${basename}/settlement`}
              selected={selected === 'settlement'}
            />
          </Grid>
          <Grid item>
            <MenuItem
              image={process.env.PUBLIC_URL + '/static/images/menu_address_book.svg'}
              selectedImage={process.env.PUBLIC_URL + '/static/images/menu_address_book_selected.svg'}
              text={'주소록'}
              link={`${basename}/address_book`}
              selected={selected === 'address_book'}
            />
          </Grid>
          <Grid item>
            <MenuItem
              image={process.env.PUBLIC_URL + '/static/images/menu_env.svg'}
              selectedImage={process.env.PUBLIC_URL + '/static/images/menu_env_selected.svg'}
              text={'환경설정'}
              link={`${basename}/env`}
              selected={selected === 'env'}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <ListItem
          button
          className={classes.menuItem}
          onClick={(event) => {
            event.preventDefault();

            getAuthServiceInstance(navigate).logout();
            navigate(`${basename}/login`, { replace: true });
          }}
        >
          <Grid container direction={'column'} alignItems={'center'}>
            <Grid item>
              <img src={process.env.PUBLIC_URL + '/static/images/menu_logout.svg'} alt={'로그아웃'}/>
            </Grid>
            <Grid item className={classes.menuText}>
              <span>{'로그아웃'}</span>
            </Grid>
          </Grid>
        </ListItem>
      </Grid>
    </Grid>
  );
}